import requestv2 from "~/utils/http-v2";

const buyServiceApi = {
	gets : async (params) => {
		const url = 'v2/buy-service';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/buy-service';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/buy-service/${params.id}`;
		return await requestv2.patch(url, params);
	},
	status : async (params) => {
		const url = `v2/buy-service/status/${params.id}`;
		return await requestv2.post(url, params);
	},
	buy : async (params) => {
		const url = `v2/buy-service/buy/${params.id}`;
		return await requestv2.post(url, params);
	},
	delete : async (id) => {
		const url = `v2/buy-service/${id}`;
		return await requestv2.delete(url);
	},
	fileUpload : async (params) => {
		const url = `v2/buy-service/file/${params.id}`;
		return await requestv2.post(url, params, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	},
	fileRemove : async (params) => {
		const url = `v2/buy-service/file/delete/${params.id}`;
		return await requestv2.post(url, params);
	},
};

export default buyServiceApi;